import DropdownIconWhite from './admin/dropdown-icon-white.svg';
import ActionEditBlue from './admin/edit-icon-blue.svg';
import ActionEditGray from './admin/edit-icon-gray.svg';
import FilterIconBlue from './admin/filter-icon-blue.svg';
import FilterIconWhite from './admin/filter-icon-white.svg';
import NoDataIcon from './admin/no-data-icon.svg';
import ResetIconBlue from './admin/reset-icon-blue.svg';
import ResetIconGray from './admin/reset.svg';
import ActionDeleteIcon from './admin/table-delete-icon.svg';
import ActionViewBlue from './admin/table-eye-blue.svg';
import ActionViewGray from './admin/table-eye-icon.svg';
import TableSortIcon from './admin/table-sort-icon.svg';
import RoleAddIcon from './admin/role-add-icon.svg';
import AssignModalArrow from './admin/assignModal-Arrow.png';

import AudioThumbIcon from './audio-player/audio-image-thumb.svg';
import DownloadAudioIcon from './audio-player/download-audio.svg';
import MoreDotsIcon from './audio-player/more-dots-menu.svg';
import PauseBtnIcon from './audio-player/pause-btn.svg';
import PlayBtnIcon from './audio-player/play-btn.svg';
import RepeatBtnIcon from './audio-player/repeat-icon.svg'; 
import RepeatOneIcon from './audio-player/repeat-one.svg';
import MuteIcon from './audio-player/mute-icon.svg';
import UnMuteIcon from './audio-player/unMute-icon.svg';

import ActiveStatusIcon from './bibleSeminars/active-status-icon.svg';
import InactiveStatusIcon from './bibleSeminars/inactive-status-icon.svg';
import SeminarCarouselImg1 from './bibleSeminars/seminar1.png';
import SeminarCarouselImg2 from './bibleSeminars/seminar2.png';
import SeminarCarouselImg3 from './bibleSeminars/seminar3.png';

import AddBlueIcon from './common/add-blue.svg';
import AddBlueIconCircled from './common/add-icon-blue-circle.svg';
import AddIconDisabled from './common/add-icon-disabled.svg';
import AddWhiteIcon from './common/add-white.svg';
import ArrowBlackRight from './common/arrow-black-right.svg'; 
import ArrowBlue from './common/arrow-blue.svg';
import ArrowGrayLeft from './common/arrow-gray-left.svg';
import ArrowIcon from './common/arrow-icon.svg';
import ArrowWhiteLongIcon from './common/arrow-long-white.svg';
import CloseCircleIcon from './common/close-circle-icon.svg';
import CloseGrayIcon from './common/close-gray.svg';
import CollpseMinusIcon from './common/collapse-minus.svg';
import DocumentIcon from './common/document-svg.svg';
import DownloadBlueIcon from './common/download-collpse-icon.svg';
import DownloadIconDisabled from './common/download-icon-disabled.svg';
import DownloadIconWhite from './common/download-icon-white.svg';
import DownloadIcon from './common/download-icon.svg';
import DropdownIconGray from './common/dropdown-icon-gray.svg';
import EmailBlueLgIcon from './common/email-blue-lg.svg';
import ExpandPlusIcon from './common/expand-plus.svg';
import EyeIcon from './common/eye-svg.svg';
import FacebookIcon from './common/facebook.svg';
import HelpIconGray from './common/help-btn-gray.svg';
import HelpIcon from './common/help-icon.svg';
import HidePassword from './common/hidden-eye.svg';
import InfoBlackIcon from './common/info-black-icon.svg';
import InfoBlueIcon from './common/info-blue-icon.svg';
import InfoIconGray from './common/info-gray.svg';
import InstagramIcon from './common/instagram.svg';
import LinkedInIcon from './common/linkedin.svg';
import MinusIcon from './common/minus.svg';
import ReadIconBlue from './common/read-arrow-blue.svg';
import SearchIcon from './common/search-icon.svg';
import SearchInputIcon from './common/search-input-icon.svg';
import SettingsIcon from './common/settings-icon.svg';
import TwitterIcon from './common/twitter.svg';
import UploadXlsxIcon from './common/uploadlist-file-icon-xlsx.svg';
import ShowPassword from './common/visibility.svg';
import PlayListIcon from './common/playlist.svg';
import BookMarkIcon from './common/bookmark.svg';
import SuccessIcon from './common/success-icon.svg';
import UnSuccessIcon from './common/unsuccessful-icon.png';

import DownloadGrayIcon from './ecclesialDocuments/download-gray-icon.svg';
import EditBlackIcon from './ecclesialDocuments/edit-black-icon.svg';
import SelectPDFIcon from './ecclesialDocuments/select-pdf-icon.svg';
import UploadListDocIcon from './ecclesialDocuments/uploadlist-file-icon-doc.svg';

import FooterEmailIcon from './footer/footer-email.svg';
import FooterContactIcon from './footer/footer-contact.svg';
import FooterLocationIcon from './footer/footer-location.svg';

import Logo from './header/logo.webp';
import LogoutIcon from './header/logout-icon.svg';
import MailIcon from './header/mail.svg';
import HeaderMenuIcon from './header/menu-icon.svg';
import NotificationsIcon from './header/notifications.svg';
import UserCircleIcon from './header/user-circle.svg';
import closeIcon from './header/closeIcon.svg';

import CarouselBg1 from './home/home-bg1.webp';
import WebcastBg from './home/background-1.webp';
import VideoRecBg from './home/background-2.webp';

import AudioClockIcon from './mediaPlayer/audio-clock.svg';
import AudioDownloadIcon from './mediaPlayer/audio-download.svg';
import DeleteIcon from './mediaPlayer/delete-icon.svg';
import DownloadDocIcon from './mediaPlayer/download-doc-icon.svg';
import FranceIcon from './mediaPlayer/france.svg';
import GermanyIcon from './mediaPlayer/germany.svg';
import GreenStrokeIcon from './mediaPlayer/green-stroke.svg';
import IndonesiaIcon from './mediaPlayer/indonesia.svg';
import MetaDataPendingIcon from './mediaPlayer/meta-pending-icon.svg';
import MoreIcon from './mediaPlayer/more-icon.svg';
import PagesIcon from './mediaPlayer/pages-icon.svg';
import AudioImageIcon from './mediaPlayer/audio-image.svg';
import PauseAudioIcon from './mediaPlayer/pause-audio-icon.svg';
import PDFIcon from './mediaPlayer/pdf-icon.svg';
import PlayAudioIcon from './mediaPlayer/play-audio-icon.svg';
import PlaylistIcon from './mediaPlayer/playlist.svg';
import PrintIcon from './mediaPlayer/print-icon.svg';
import ShareIcon from './mediaPlayer/share-icon.svg';
import UnitedKingdomIcon from './mediaPlayer/united-kingdom.svg';
import UploadBtnIcon from './mediaPlayer/upload-cloud-icon.svg';
import UploadCompleteIcon from './mediaPlayer/upload-complete-icon.svg';
import UploadDoneIcon from './mediaPlayer/upload-success-icon.svg';
import UploadingVideoIcon from './mediaPlayer/uploading-video-icon.svg';
import UploadListAudio from './mediaPlayer/uploadlist-file-icon-audio.svg';
import UploadListVideo from './mediaPlayer/uploadlist-file-icon-video.svg';
import VideoUploading from './mediaPlayer/video-uploading-icon.svg';

import CameraIcon from './profile/camera-icon.svg';
import EditIcon from './profile/edit-icon.svg';
import MailIconBlack from './profile/mail-black.svg';
import PhoneIconBlack from './profile/phone-black.svg';
import ProfileImg from './profile/profile-img.webp';
import UserProfileImg from './profile/user-profile-img.png';

import BackBtnPublicEvnts from './publicEvents/backPublicEventIcon.svg';
import MoreBtnIcon from './publicEvents/more-horizontal-icon.svg';
import PublicEventsBg1 from './publicEvents/public-events-bg1.png';
import PublicEventsBg2 from './publicEvents/public-events-bg2.png';

import EditLinkIcon from './resources/edit-icon-blue.svg';
import ResourceImg1 from './resources/resource-img-1.webp';
import ResourceImg2 from './resources/resource-img-2.webp';
import ResourceImg3 from './resources/resource-img-3.webp';
import ResourceImg4 from './resources/resource-img-4.webp';
import ResourceImg5 from './resources/resource-img-5.webp';

import ChristadelphianIcon from './webcast/christadelphian-icon.svg';
import DocumentTableIcon from '../imgs/webcast/document-icon.svg';
import WebcastGuestBg from './webcast/guest-bg.webp';
import GuestIcon from './webcast/guest-icon.svg';
import MemberIcon from './webcast/member-icon.svg';

import CarouselImg1 from './what-we-believe/carousel-img1.webp';
import CarouselImg2 from './what-we-believe/carousel-img2.webp';
import CarouselImg3 from './what-we-believe/carousel-img3.webp';
import CarouselImg4 from './what-we-believe/carousel-img4.webp';

export const BRImages = {
    AdminImages: {
        DropdownIconWhite,
        ActionEditBlue,
        ActionEditGray,
        FilterIconBlue,
        FilterIconWhite,
        NoDataIcon,
        ResetIconBlue,
        ResetIconGray,
        ActionDeleteIcon,
        ActionViewBlue,
        ActionViewGray,
        TableSortIcon,
        RoleAddIcon,
        AssignModalArrow
    },
    AudioImages: {
        AudioThumbIcon,
        DownloadAudioIcon,
        MoreDotsIcon,
        PauseBtnIcon,
        PlayBtnIcon,
        RepeatBtnIcon,
        RepeatOneIcon,
        MuteIcon,
        UnMuteIcon
    },
    BibleSeminarImages: {
        ActiveStatusIcon,
        InactiveStatusIcon,
        SeminarCarouselImg1,
        SeminarCarouselImg2,
        SeminarCarouselImg3
    },
    CommonImages: {
        AddBlueIcon,
        AddBlueIconCircled,
        AddIconDisabled,
        AddWhiteIcon,
        ArrowBlackRight,
        ArrowBlue,
        ArrowGrayLeft,
        ArrowIcon,
        ArrowWhiteLongIcon,
        CloseCircleIcon,
        CloseGrayIcon,
        CollpseMinusIcon,
        DocumentIcon,
        DownloadBlueIcon,
        DownloadIconDisabled,
        DownloadIconWhite,
        DownloadIcon,
        DropdownIconGray,
        EmailBlueLgIcon,
        ExpandPlusIcon,
        EyeIcon,
        FacebookIcon,
        HelpIconGray,
        HelpIcon,
        HidePassword,
        InfoBlackIcon,
        InfoBlueIcon,
        InfoIconGray,
        InstagramIcon,
        LinkedInIcon,
        MinusIcon,
        ReadIconBlue,
        SearchIcon,
        SearchInputIcon,
        SettingsIcon,
        TwitterIcon,
        UploadXlsxIcon,
        ShowPassword,
        PlayListIcon,
        BookMarkIcon,
        SuccessIcon,
        UnSuccessIcon
    },
    EcclesialImages: {
        DownloadGrayIcon,
        EditBlackIcon,
        SelectPDFIcon,
        UploadListDocIcon
    },
    FooterImages: {
        FooterEmailIcon,
        FooterContactIcon,
        FooterLocationIcon
    },
    HeaderIcons: {
        Logo,
        LogoutIcon,
        MailIcon,
        HeaderMenuIcon,
        NotificationsIcon,
        UserCircleIcon,
        closeIcon
    },
    HomeImages: {
        CarouselBg1,
        WebcastBg,
        VideoRecBg
    },
    MediaPlayerImages: {
        AudioClockIcon,
        AudioDownloadIcon,
        DeleteIcon,
        DownloadDocIcon,
        FranceIcon,
        GermanyIcon,
        GreenStrokeIcon,
        IndonesiaIcon,
        MetaDataPendingIcon,
        MoreIcon,
        PagesIcon,
        AudioImageIcon,
        PauseAudioIcon,
        PDFIcon,
        PlayAudioIcon,
        PlaylistIcon,
        PrintIcon,
        ShareIcon,
        UnitedKingdomIcon,
        UploadBtnIcon,
        UploadCompleteIcon,
        UploadDoneIcon,
        UploadingVideoIcon,
        UploadListAudio,
        UploadListVideo,
        VideoUploading
    },
    ProfileImages: {
        CameraIcon,
        EditIcon,
        MailIconBlack,
        PhoneIconBlack,
        ProfileImg,
        UserProfileImg
    },
    PublicEventsImages: {
        BackBtnPublicEvnts,
        MoreBtnIcon,
        PublicEventsBg1,
        PublicEventsBg2
    },
    ResourceImages: {
        EditLinkIcon,
        ResourceImg1,
        ResourceImg2,
        ResourceImg3,
        ResourceImg4,
        ResourceImg5
    },
    WebCastImages: {
        ChristadelphianIcon,
        DocumentTableIcon,
        WebcastGuestBg,
        GuestIcon,
        MemberIcon
    },
    WhatWeBelieveImages: {
        CarouselImg1,
        CarouselImg2,
        CarouselImg3,
        CarouselImg4
    }
}
